import { useEffect } from "react";
import { ref, update, remove } from "firebase/database";
import { rtdb } from "../firebase";
import { getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../context/authContext";

export function useSyncRPM(rpm, energy, started, gymId, claseId, nombreUsuario, estadoClase) {
  useEffect(() => {
    const iniciarSync = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        console.warn("⚠️ No hay usuario autenticado, no se pueden enviar RPM.");
        return;
      }

      if (!gymId || !claseId) {
        console.warn("⚠️ gymId o claseId no definidos.");
        return;
      }

      const uid = user.uid;
      const userRef = ref(rtdb, `clases/${gymId}/${claseId}/usuarios/${uid}`);

      if (estadoClase === "cerrada") {
        remove(userRef)
          .then(() => console.log("🧹 Nodo eliminado al cerrar clase."))
          .catch((err) => console.error("❌ Error eliminando nodo:", err));
        return;
      }

      if (estadoClase !== "abierta") {
        console.log("⏸ Clase no abierta, no enviamos RPM.");
        return;
      }

      let nombreFinal = nombreUsuario || "Anónimo";

      try {
        const userDocRef = doc(db, "usuarios", uid);
        const userSnap = await getDoc(userDocRef);

        if (userSnap.exists()) {
          const userData = userSnap.data();
          nombreFinal = userData.nombre || nombreUsuario || "Anónimo";
        }
      } catch (err) {
        console.error("❌ Error leyendo nombre desde Firestore:", err);
      }

      const rpmFinal = started ? Number(rpm) || 0 : 0;
      const energyFinal = rpmFinal < 5 ? 0 : Number(energy) || 0;

      const data = {
        nombre: nombreFinal,
        gym: gymId,
        claseId,
        rpm: rpmFinal,
        energy: energyFinal,
        activo: true,
        timestamp: Date.now(),
      };

      update(userRef, data)
        .then(() => console.log("📡 RPM/Energy actualizado:", data))
        .catch((err) =>
          console.error("❌ Error enviando RPM/Energy:", err.code, err.message)
        );
    };

    iniciarSync();
  }, [rpm, energy, started, gymId, claseId, nombreUsuario, estadoClase]);
}